/**
 * 自定义指令
 * **/

import Vue from "vue";

// style控制显示与否 （占位）
Vue.directive("visible", {
    bind(el, binding) {
        if (el) {
            const visible = Boolean(binding.value)
            el.style.visibility = visible ? 'visible' : 'hidden'
        }
    },
    update(el, binding) {
        if (el) {
            const visible = Boolean(binding.value)
            el.style.visibility = visible ? 'visible' : 'hidden'
        }
    },
});


Vue.directive('telephone', {
    bind(el, binding, vnode) {
        const handler = (str) => {
            if (!str) return;
            let res = String(str).replace(/[^0-9]/g, '');
            if (binding.modifiers.gap) {
                const arr = [res.substr(0, 3), res.substr(3, 4), res.substr(7)].filter((a) => a);
                res = arr.join(' ');
            }
            el.value = res || '';
            if (str !== el.value) {
                el.dispatchEvent(new Event('input'))
            }
        }

        handler(el.value);

        el.fn = (e) => {
            handler(e.target.value)
        }

        el.addEventListener('input', el.fn)
    },
    unbind(el) {
        el.removeEventListener('input', el.fn)
    }
})

/**
 * 监听 dom 节点高度变化
 */
Vue.directive('resize', {
    bind(el, binding) {
		function get() {
			const style = document.defaultView.getComputedStyle(el);
            if (style.height) {
                binding.value({height: style.height});
                // clearInterval(el.__vueReize__);
            }
      	}

      	el.__vueReize__ = setInterval(get, 200);
    },
    unbind(el) {
      clearInterval(el.__vueReize__);
    },
});